// extracted by mini-css-extract-plugin
module.exports = {"contactsListTable":"ContactsList_contactsListTable__ktmCt","mediumTable":"ContactsList_mediumTable__21sbh","mobileTable":"ContactsList_mobileTable__2lOh0"};